import React, { Component } from 'react';
import PropTypes from 'prop-types';
import anime from 'animejs';
import Bind from 'lodash-decorators/bind';
import Debounce from 'lodash-decorators/debounce';

import styles from './CompanyBox.module.scss';

import { isOnMobile } from 'utils/device-utils';

export default class CompanyBox extends Component {
  static propTypes = {
    companyName: PropTypes.string,
    companySubtitle1: PropTypes.string,
    companySubtitle2: PropTypes.string,
    companyDescription: PropTypes.string,
    isFadeInActive: PropTypes.func.isRequired
  };

  static defaultProps = {
    products: []
  };

  constructor(props) {
    super(props);
    this.state = {
      companies: props.companies,
      companiesNext: props.companies,
      fadeInActive: false,
      activeSlideIndex: props.activeSlideIndex,
      isMobile: isOnMobile()
    };

    this.animationDuration = 750;
    this.columnEasing = 'easeInOutCubic';
    this.boxesTranslateY = '50';
    this.introTranslateX = '100';
    this.animation = {
      Intro__Title: {
        targets: '.js-nav-intro',
        easing: 'easeInOutQuart',
        duration: this.animationDuration
      },
      GroupDescription__Title: {
        targets: '#GroupDescription-companyWrapper #companyTitle',
        easing: 'linear',
        duration: this.animationDuration
      },
      GroupDescription__Col1: {
        targets: '#GroupDescription-companyWrapper #companyBox1'
      },
      GroupDescription__Col2: {
        targets: '#GroupDescription-companyWrapper #companyBox2'
      },
      GroupDescription__Col3: {
        targets: '#GroupDescription-companyWrapper #companyBox3'
      }
    };
  }

  componentDidMount() {
    window.addEventListener('resize', this.updateDimensions);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateDimensions);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    this.setState({
      companiesNext: nextProps.companies
    });

    if (this.state.activeSlideIndex !== nextProps.activeSlideIndex) {
      this.setState({ activeSlideIndex: nextProps.activeSlideIndex });
      if (this.state.companies === this.state.companiesNext) {
        this.animate(
          true,
          '0',
          this.boxesTranslateY,
          this.state.isMobile ? '0' : this.introTranslateX
        );
      }
    }
  }

  @Bind()
  @Debounce(100)
  updateDimensions() {
    this.setState({
      isMobile: isOnMobile()
    });
  }

  render() {
    const { companies } = this.state;
    return (
      <div id="GroupDescription-companyWrapper">
        <h2 className={styles.Title} id="companyTitle">
          {companies.name}
        </h2>
        <div className={styles.InfoWrapper}>
          <div className={styles.InfoBox} id="companyBox1">
            <div
              className={styles.Paragraph}
              dangerouslySetInnerHTML={{ __html: companies.descriptionColumn1 }}
            />
          </div>
          <div className={styles.InfoBox} id="companyBox2">
            <div
              className={styles.Paragraph}
              dangerouslySetInnerHTML={{ __html: companies.descriptionColumn2 }}
            />
          </div>
          <div className={styles.InfoBox} id="companyBox3">
            <div
              className={styles.Paragraph}
              dangerouslySetInnerHTML={{ __html: companies.descriptionColumn3 }}
            />
          </div>
        </div>
      </div>
    );
  }

  animate(isFadeOut, opacity, boxesTransition, IntroTransition) {
    anime({
      opacity: opacity,
      ...this.animation.GroupDescription__Title
    });

    anime({
      opacity: opacity,
      translateX: IntroTransition,
      ...this.animation.Intro__Title
    });

    const basicTimeline = anime.timeline({
      duration: this.animationDuration / 3,
      easing: this.columnEasing,
      complete: anim => {
        if (isFadeOut) {
          this.setState({
            companies: this.state.companiesNext,
            fadeInActive: true
          });
          this.animate(false, '1', '0', '0');
        }
        if (!isFadeOut) {
          this.setState({
            fadeInActive: false
          });
        }
        this.FadeInActive(this.state.fadeInActive);
      }
    });
    basicTimeline
      .add({
        ...this.animation.GroupDescription__Col1,
        translateY: boxesTransition,
        opacity: opacity
      })
      .add({
        ...this.animation.GroupDescription__Col2,
        translateY: boxesTransition,
        opacity: opacity
      })
      .add({
        ...this.animation.GroupDescription__Col3,
        translateY: boxesTransition,
        opacity: opacity
      });
  }

  FadeInActive(bool) {
    this.props.isFadeInActive(bool);
  }
}



// WEBPACK FOOTER //
// ./src/views/Home/Sections/Intro/Components/CompanyBox/CompanyBox.js